import styled from "styled-components";

export const CardList = styled.div`
border: 00.0625rem rgba(0,0,0,0.125) solid;
border-radius: 0.20rem;
background-color: white;
box-shadow: 0.05rem 0.05rem 0.5rem rgba(0,0,0,0.125);
padding: 10px;

header {
  display: flex;
  height: min-content;
  justify-content: space-between;

  @media (max-width: 760px) {
    flex-direction: column;
    button {
      margin-bottom: 20px;
    }
  }
}
`;

export const ContainerCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: min-content;
  width: inherit;
  /* border: 1px solid black; */
  margin: 0 !important;
`;
